module.exports = __webpack_public_path__ + "static/media/poiPin.507b5d13.png";